import React from "react";
import { Box, Typography } from "@mui/material";
import AgentAvatar from "./AgentAvatar";
import useAgentStore from "./useAgentStore";
import useProjectStore from "../ProjectCanvas/useProjectStore";
import { getClickableAgentAvatarSx } from "./agentSessionsPanelUtils";
import { PAGE_HEADER_HEIGHT_PX } from "../../constants/pageLayout";
import LiveDots from "../common/LiveDots";

export default function PendingChatView({
  agentName,
  agentId,
  onOpenAgentSettings,
  pendingMessage,
  forceUserNameAsYou = false,
  publicUserDisplayName = "",
}) {
  const sessionDetail = useAgentStore((state) => state.sessionDetail);
  const optimisticMsg = sessionDetail?.messages?.find((m) => m._optimistic && m.role === "user");
  const pending = pendingMessage !== undefined ? pendingMessage : optimisticMsg?.content;
  const avatarClick =
    onOpenAgentSettings && agentId
      ? (event) => {
          event.stopPropagation();
          onOpenAgentSettings(agentId);
        }
      : undefined;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box
        sx={{
          px: 2,
          borderBottom: 1,
          borderColor: "divider",
          backgroundColor: "background.subtle",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flexShrink: 0,
          height: PAGE_HEADER_HEIGHT_PX,
          boxSizing: "border-box",
        }}
      >
        <Typography
          sx={{ fontSize: "14px", fontWeight: 600, color: "text.primary" }}
        >
          New session
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          py: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {pending &&
          (() => {
            const currentUserName = publicUserDisplayName
              || (forceUserNameAsYou
                ? null
                : useProjectStore.getState().userDisplayName
                  || useProjectStore.getState().userName);
            return (
              <Box sx={{ px: 2.5, pt: 1, py: 0.5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                  }}
                >
                  <AgentAvatar
                    name={currentUserName}
                    size={28}
                    {...(!currentUserName ? { children: "Y", sx: { bgcolor: "text.primary" } } : {})}
                  />
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color: "text.primary",
                        lineHeight: 1.4,
                      }}
                    >
                      {currentUserName || "You"}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "text.primary",
                        lineHeight: 1.6,
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        mt: 0.25,
                      }}
                    >
                      {pending}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            );
          })()}
        <Box sx={{ px: 2.5, pt: 1, py: 0.5 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
            <AgentAvatar
              agentId={agentId}
              name={agentName}
              size={28}
              onClick={avatarClick}
              engaged
              sx={getClickableAgentAvatarSx(Boolean(avatarClick))}
            />
            <Box sx={{ display: "flex", alignItems: "center", pt: "7px" }}>
              <LiveDots />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
